<ng-template let-row="row" let-icon="value">
    <div>
        <app-icon-table-cell-inside [iconData]="icon"></app-icon-table-cell-inside>
    </div>
</ng-template>
